import { useState } from "react";
import WithBackground from "../../../core/boilerplate/WithBackground";
import CustomToggle from "../../../helperComponents/CustomToggle";
import PrimaryButton from "../../../helperComponents/PrimaryButton";
import LoggedOutHeader from "../landingPage/LoggedOutHeader";
import styled from "styled-components";
import MaterialInput from "../../../helperComponents/MaterialInput";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import InputCard from "../../../helperComponents/InputCard";
import CustomButton from "../../../helperComponents/CustomButton";
import { serverLine } from "../../../../controllers/network/serverLine";
import LoadingSection from "../../../helperComponents/LoadingSection";
import MessageBox from "../../../helperComponents/MessageBox";
import { useTranslation } from "react-i18next";

const options = [
  { value: "LOGIN", label: "Login" },
  { value: "SIGNUP", label: "Signup" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  align-items: center;
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 100%;
  align-items: center;
  padding-bottom: 30px;
`;

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  align-items: flex-end;
`;

const Title = styled.div`
  font-weight: 900;
  font-size: 23px;
  font-family: var(--headingFont);
  color: var(--accentColor);
`;

const Medium = styled.div`
  /* font-weight: 900; */
  opacity: 0.4;
  font-size: 15px;
  text-align: center;
  color: var(--accentColor);
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
  align-items: center;
`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const { t } = useTranslation();

  let core = (
    <MaterialInput
      label={t("forgotPasswordEmailInputLabel")}
      value={email}
      onChange={extractEventValue(setEmail)}
    />
  );

  if (loading) core = <LoadingSection />;

  let submitButtonText = t("forgotPasswordSubmit");
  let submitButtonAction = forgotPassword;

  if (done) {
    submitButtonText = null;
    submitButtonAction = null;
    core = <MessageBox>{t("forgotPasswordEmailSent")}</MessageBox>;
  }

  return (
    <WithBackground backgroundImage="/dumbbells.jpg">
      <Container>
        <LoggedOutHeader />

        <InputCard
          title={t("forgotPasswordPageTitle")}
          desc={t("forgotPasswordPageDesc")}
          submitButtonText={submitButtonText}
          onSubmit={submitButtonAction}
        >
          {core}
        </InputCard>
      </Container>
    </WithBackground>
  );

  async function forgotPassword() {
    if (!email)
      return window.popupAlert(t("forgotPasswordPleaseEnterYourEmail"));
    setLoading(true);

    try {
      await serverLine.post("/forgot-password", { email });
      setLoading(false);
      setDone(true);
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
